export default __webpack_public_path__ + "static/media/wheel_poll.1f27bfcc.svg";